module.exports = "Mit dieser gratis App kann man eine persönliche Tagesrune ziehen. Man formuliert den Runensteinen zuerst eine Frage, eingebettet in ein Gefühl für die Situation, um welche sich die Frage dreht. Die Runensteine werden sich formen und die Richtung zeigen.";


//////////////////
// WEBPACK FOOTER
// ./lib/home-view/dailyrune_desc.html
// module id = 45
// module chunks = 0